<template>
	<div id="userfocus" class="">
		<!-- 政府端 -->
		<leftnav class="fl" mkcode="B" itemcode="B-DDTP" :title="title"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox industrialpark" style="min-height: 600px;">
					<div class="right_boxtitle">
						<span class="fl right_title">当地图谱-关注领域</span>
						<el-tooltip effect="light" placement="top-start">
							<i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px; "></i>
							<div slot="content" class="list_tips">
								<p>1.概念添加上限为80个左右，如遇上限，可适当删除旧概念，再进行新增</p>
								<p>2.如果关注的领域无本地企业，则前端无数据显示</p>
							</div>
						</el-tooltip>

					</div>
					<dl class="opport-screen bdbe">
						<dt class="fl">产业分类</dt>
						<dd class="fl screenop">
							<span v-for="(item, index) in notionlist" v-show="item.label.indexOf('未来') < 0"
								:class="code1 == item.value ? 'a-screen current' : 'a-screen'"
								@click="chooseNotion(1, item)">{{ item.label }}</span>
						</dd>
					</dl>
					<dl class="opport-screen bdbe" v-show="notionlist1.length > 0">
						<dt class="fl titleop">一级产业</dt>
						<dd class="fl">
							<span v-for="(item, index) in notionlist1"
								:class="code2 == item.value ? 'a-screen current' : 'a-screen'" @click="chooseNotion(2, item)"
								v-show="item.label != '环保'">{{ item.label }}</span>
						</dd>
					</dl>
					<dl class="opport-screen bdbe" v-show="notionlist2.length > 0">
						<dt class="fl titleop">二级细分</dt>
						<dd class="fl">
							<!-- <span @click="chooseNotion(3,'all',fenkd)" :class="chooseNotionlist[2]==0 ?'a-screen current':'a-screen'">全部</span> -->
							<span v-for="(item, index) in notionlist2"
								:class="checktext.indexOf(item.label) > -1 ? 'a-screen current' : 'a-screen'"
								@click="chooseNotion(3, item)">{{ item.label }}</span>
						</dd>
					</dl>
					<!-- <p>{{checkcode}}</p> -->
					<!--  v-show="notionlistdefault.length>0" -->
					<!-- <p>{{checkcode}}</p> -->
					<p v-show="checkarry.length < 1" style="padding: 15px 20px;">暂无已选概念</p>
					<dl class="usernotiontitle" v-show="checkarry.length > 0">
						<dt class="title">已选概念</dt>
						<dd>
							<p class="notionarea"><span class="basefont selected_tag"
									v-for="item in checkarry">{{ item.label }}<i @click="ckll(item)"
										class="concept_notionlist el-icon-close"></i></span></p>
						</dd>
					</dl>
					<div class="oh" style="padding-top: 20px;"><span
							:class="emptybtn ? 'userfocus_save fr' : 'userfocus_save fr gray'" @click="empty()"
							v-show="checkarry.length > 0">清空</span>
						<span class="fr userfocus_save" @click="getchoosevalue('save')" v-show="editbtn">保存</span>
					</div>
				</div>

			</div>
		</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'chainNotion',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			title: '当地图谱-关注领域',
			showfixednotion: false, editbtn: false, emptybtn: true,
			notionlistdefault: [],
			notionlist: [],
			notionlist1: [],
			notionlist2: [],
			notionlist3: [], code1: 'A', code2: 'A01', code2text: '',
			notionlist4: [], notiontext: '', notionCode: 0, chooseNotionlist: ['A', 0, 0, 0, 0],
			allnotionlist: [],
			checktext: "", checkcode: "", checkarry: [],
			checkparenttext: "", checkparentcode: "", checkparentarry: [],
			flodnum: false,
			indexnum: 1,
			choosenotionlength: 20,

		}
	},
	created() {
		this.userdata = this.getuserinformain();
	},
	mounted() {
		this.getusernlist();
		this.getallnotionlist();
	},
	methods: {
		//获取用户已筛选的数据
		getusernlist() {
			var _this = this;
			this.$axios.get(this.$api.cyl.localchain.get(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log('用户设置的概念数据', res.data.data)
				if (res.data.success) {
					if (res.data.data.notionText != '') {
						_this.checktext = res.data.data.notionText;
						_this.checkcode = res.data.data.notion;
						var checktextd = _this.checktext.split(',');
						var checkcoded = _this.checkcode.split(',');
						for (var i = 0; i < checktextd.length; i++) {
							_this.checkarry.push({ value: checkcoded[i], label: checktextd[i] });
						}
					}
				} else {

				}
			});
		},
		//将概念数据分类
		getallnotionlist() {
			//三大产业概念数据
			var _this = this;
			this.$axios.get(this.$api.tag.notion.list() + '?level=3', { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log(res.data)
				if (res.data.success) {
					_this.notionlist = res.data.list;
					_this.notionlist1 = _this.notionlist[0].children;
					_this.notionlist2 = _this.notionlist[0].children[0].children;
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		swapArr(arr, index1, index2) { //调换数组元素位置
			arr[index1] = arr.splice(index2, 1, arr[index1])[0];
			return arr
		},
		//概念单选 层级显示
		chooseNotion(step, data) {
			if (step == 1) {
				this.notionlist1 = data.children; this.code1 = data.value;
				this.notionlist2 = [];
			} else if (step == 2) {
				this.notionlist2 = data.children; this.code2 = data.value;
				// this.code2text=data.label;
				if (this.checkparenttext.indexOf(data.label + ',') < 0) {
					this.checkparenttext = this.checktext + data.label + ',';
					this.checkparentarry.push({ value: data.value, label: data.label });
				}
			} else if (step == 3) {
				this.editbtn = true;
				if (this.checktext.indexOf(data.label) < 0) {
					// this.checktext=this.checktext+data.label+',';
					// this.checkcode=this.checkcode+data.value+',';
					this.checkarry.push(data);
				} else {
					this.checkarry = this.checkarry.filter(list => {
						return list.value != data.value;
					});
				}
				this.arrytext();
			}
			if (this.checkarry.length > 0) {
				this.emptybtn = true;
			}
			// console.log(this.notionCode);
			// this.ajaxsearchcompany();
		},
		empty() {
			this.checkarry = [];
			this.checkcode = "";
			this.checktext = ""; this.emptybtn = false;
			this.editbtn = true;
		},
		ckll(data) {
			this.checkarry = this.checkarry.filter(list => {
				return list.value != data.value;
			});
			this.arrytext();
			// console.log(this.checkarry,this.checktext.indexOf(data.label+','))
		},
		arrytext() {
			this.editbtn = true;
			let texta = "", codea = "";
			let textarr = [], codearr = [];
			// console.log(this.checkarry)
			for (var i = 0; i < this.checkarry.length; i++) {
				textarr.push(this.checkarry[i].label);
				codearr.push(this.checkarry[i].value);
			}
			this.checktext = textarr.join(',');
			this.checkcode = codearr.join(',');
		},
		//点击确认后拿取数据
		getchoosevalue(type) {
			var ajaxnotiontext = this.checkcode;
			var ajaxurl = this.$api.cyl.localchain.set();
			var _this = this;
			console.log(ajaxnotiontext)
			var textmsg = ajaxnotiontext.length > 1 ? '保存成功' : '已清空当前所选，恢复初始设置概念'
			// return;
			if (type == 'save') {
				$.ajax({
					type: "POST",
					url: ajaxurl,
					data: { notionList: ajaxnotiontext },
					headers: { AuthToken: this.userdata.token },
					success: function (res) {
						console.log(res);
						if (res.success) {
							if (type == 'save') {
								let texts = res.data.notionText.split(',');
								let codes = res.data.notion.split(',');
								let sbc = [];
								for (var i = 0; i < texts.length; i++) {
									sbc.push({ label: texts[i], value: codes[i] })
								}
								_this.checkarry = sbc;
								_this.checktext = res.data.notionText;
								_this.checkcode = res.data.notion;
								_this.$message({
									type: 'success',
									message: textmsg,
								});
							}
						}
					}
				});
			}
		},

	}
}  
</script>

<style></style>



